// extracted by mini-css-extract-plugin
module.exports = {"formSection":"invitation_formSection__17Gxv","input":"invitation_input__1qaJL"};